import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import sharedMessages from '@/lib/shared-messages';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkDownloadDialog',
  props: {
    value: { type: Boolean },
    pdfDownloadCount: null,
    pdfMonthlyLimit: null
  },
  emits: ["input", "download"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'download'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  pdfDownloadCount: number;
  pdfMonthlyLimit: number;
};

const m = defineMessages({
  pdfDownloadModalHeader: '選択中のSDSをダウンロードしますか？',
  pdfDownloadProcessModalBodyFText:
    '「実行する」をクリックすると、ご自身のメールアドレスにファイルダウンロードURLが記載されたメールが送信されます。',
  pdfDownloadProcessModalBodySTextNew:
    '※SDS一括ダウンロード機能は、1契約ごとに月10,000件までとなります。',
  pdfDownloadProcessModalBodySTextOld:
    '※SDS一括ダウンロード機能は、1契約ごとに月10回までとなります。',
  pdfDownloadProcessModalBodyTText:
    '※一度の操作でダウンロードできるファイル数は最大3000件です。',
  pdfDownloadProcessModalBodyLText: 'ダウンロード残数',
  pdfDownloadProcessStatus: '（今月）',
});





const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

const downloadableCount = computed((): number => {
  return props.pdfMonthlyLimit - props.pdfDownloadCount;
});

const closeDialog = () => {
  model.value = false;
};

const handleExecuteClick = () => {
  emit('download');
  closeDialog();
};

const handleCancelClick = () => {
  closeDialog();
};

return { __sfc: true,m, props, emit, model, downloadableCount, closeDialog, handleExecuteClick, handleCancelClick, BaseFormCard, sharedMessages }
}

})